import { render, staticRenderFns } from "./NewTicketDialog.vue?vue&type=template&id=32e3b67a&scoped=true"
import script from "./NewTicketDialog.vue?vue&type=script&lang=js"
export * from "./NewTicketDialog.vue?vue&type=script&lang=js"
import style0 from "./NewTicketDialog.vue?vue&type=style&index=0&id=32e3b67a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e3b67a",
  null
  
)

export default component.exports